import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white/70" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="bg-white rounded-2xl p-1.5 shadow-[0_4px_14px_rgba(0,0,0,0.25)]">
              <img src="/logo-512.png" alt="Shonta Solutions LLC" className="h-12 w-auto" />
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            Full-service short-term rental co-hosting and property management. Professional,
            transparent, and hands-off — so you can enjoy the benefits of ownership.
          </p>
          <a
            href="mailto:shontasolutions@currently.com"
            className="mt-4 inline-flex items-center gap-2 text-sm hover:text-[#FF5A5F] transition-colors"
            data-testid="footer-email"
          >
            <Mail className="w-4 h-4 text-[#FF5A5F]" />
            shontasolutions@currently.com
          </a>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a href="/#how-it-works" data-testid="footer-link-services" className="hover:text-[#FF5A5F] transition-colors">Our Services</a></li>
            <li><a href="/#why-us" data-testid="footer-link-why-us" className="hover:text-[#FF5A5F] transition-colors">Why Owners Choose Us</a></li>
            <li><a href="/#partnership" data-testid="footer-link-partnership" className="hover:text-[#FF5A5F] transition-colors">Partnership Offer</a></li>
            <li><a href="/#faq" data-testid="footer-link-faq" className="hover:text-[#FF5A5F] transition-colors">FAQ</a></li>
            <li><a href="/shonta-solutions-results.pdf" target="_blank" rel="noopener noreferrer" data-testid="footer-link-results-pdf" className="hover:text-[#FF5A5F] transition-colors">Results Report (PDF)</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-white text-sm tracking-widest uppercase">Service Inquiries</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a href="/#contact" data-testid="footer-link-consultation" className="hover:text-[#FF5A5F] transition-colors">Apply for the Partnership</a></li>
            <li><a href="/#contact" data-testid="footer-link-contact" className="hover:text-[#FF5A5F] transition-colors">Contact Us</a></li>
            <li><a href="#" data-testid="footer-link-privacy" className="hover:text-[#FF5A5F] transition-colors">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Shonta Solutions LLC. All rights reserved.</span>
          <span>Short-term rental co-hosting &amp; vacation rental management.</span>
        </div>
      </div>
    </footer>
  );
}
